// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails";
// import "@hotwired/turbo-rails"
// import "../sites/tapheartrate/controllers/index"
import * as bootstrap from "bootstrap";

import onLoadShared from "~/shared/on_load";
onLoadShared.run();

import onLoad from "../sites/tapheartrate/on_load";
onLoad.run();

Turbo.session.drive = false;
